(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('GeneralActionsBottomSheetController', GeneralActionsBottomSheetController);

    GeneralActionsBottomSheetController.$inject = ['$mdBottomSheet', '$state'];

    function GeneralActionsBottomSheetController($mdBottomSheet, $state) {
        var vm = this;

        vm.itemClick = itemClick;
        vm.close = close;

        function itemClick(txt) {
            $mdBottomSheet.hide(txt);
            runAction(txt);
        }

        function close() {
            $mdBottomSheet.hide();
        }

        function runAction(txt) {
            switch (txt) {
                case 'newReserve' :
                    $state.go('supplierPanel-v2.new-reserve-modal');
                    break;
                case 'closeDates' :
                    $state.go('supplierPanel-v2.calendar.servantExceptionTimes', {
                        availabilityMode: 'CLOSE'
                    });
                    break;
                case 'openDates' :
                    $state.go('supplierPanel-v2.calendar.servantExceptionTimes', {
                        availabilityMode: 'OPEN'
                    });
                    break;
            }
        }
    }
})();
